import { RootState } from "app/rootReducer";
import { Dispatch } from "react";
import { StudentActions } from "./studentSlice";
import { dispatchAsyncFunction, getTokenFromState } from "../sliceHelpers";
import { fetchStudent } from "../../api";

const dispatchFetchStudent = (studentId: string, actions: StudentActions) => async (
  dispatch: Dispatch<any>,
  getState: () => RootState
) =>
  await dispatchAsyncFunction(async () => {
    const { token } = getTokenFromState(getState);
    const data = await fetchStudent({ token, studentId });

    dispatch(actions.mergeStudent(data));
  }, dispatch);

export { dispatchFetchStudent };
